import { Button } from '@dfh-corp-sites/ui'
import { FacebookIcon, InstagramIcon, TikTokIcon, XSocialIcon } from '@dfh-corp-sites/ui/icons'
import { cn } from '@dfh-corp-sites/ui/utils'
import React from 'react'

import { Maybe, SanityContact } from '../../../groq/sanity-dispensaries/types'
import Link from '../../global/Link'

const IconButton = ({ icon, href }: { icon: React.ReactNode; href: string }) => {
  return (
    <Button variant="icon" className="bg-brand-grey w-[50px] h-[50px] rounded-full" asChild>
      <Link target="_blank" to={href}>
        {icon}
      </Link>
    </Button>
  )
}

type Props = {
  contact?: Maybe<SanityContact>
}

const Information = ({ contact }: Props) => {
  if (contact?.showContactDetails === false || !contact) {
    return null
  }

  return (
    <section className="border-b-[2px] border-t-[2px] border-brand-grey">
      <div className={cn('my-10 px-10', 'max-w-[1280px] w-full mx-auto')}>
        <span className={cn(['uppercase font-medium text-brand-navy-2'])}>location</span>

        <div className={cn(['mt-2', 'md:mt-6'])}>
          <span className={cn(['text-xl font-base', 'md:text-3xl md:font-light'])}>
            {contact.address?.street?.join(', ')}.
          </span>
        </div>

        <div className="mt-1">
          <span className={cn(['text-xl font-base', 'md:text-3xl md:font-light'])}>
            {contact.address?.city}, {contact.address?.region} {contact.address?.postcode}
          </span>
        </div>

        <div className="mt-8">
          <span className="uppercase font-medium text-brand-navy-2">contact us</span>

          <div
            className={cn([
              'flex flex-col items-start gap-5 mt-2',
              'md:flex-row md:items-center md:gap-20',
            ])}
          >
            <span className={cn(['text-xl font-base', 'md:text-3xl md:font-light'])}>
              {contact.email}
            </span>

            <div>
              <span className={cn(['text-xl font-base', 'md:text-3xl md:font-light'])}>
                {contact.phone}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-8 flex gap-4 items-center">
          {contact.instagram && <IconButton icon={<InstagramIcon />} href={contact.instagram} />}
          {contact.tikTok && <IconButton icon={<TikTokIcon />} href={contact.tikTok} />}
          {contact.twitterX && <IconButton icon={<XSocialIcon />} href={contact.twitterX} />}
          {contact.facebook && <IconButton icon={<FacebookIcon />} href={contact.facebook} />}
        </div>
      </div>
    </section>
  )
}

export { Information }
